export enum Enpoints {
  TV_CHANNEL = "tv-channel"
}
